import { onMounted, onUnmounted, watch } from 'vue';
import { makeRef } from './reactivity/makeRef.js';
import { unwrapElement } from './unwrapElement.js';
/** Registers a scroll event listener on the given element, auto-cleaning up on unmount. */
export function onElementScroll(element, callback) {
    const elementRef = makeRef(element);
    watch(() => elementRef.value, (current, previous) => {
        disconnect(previous);
        connect(current);
    });
    onMounted(() => connect(elementRef.value));
    onUnmounted(() => disconnect(elementRef.value));
    function connect(el) {
        unwrapElement(el)?.addEventListener('scroll', callback, { passive: true });
    }
    function disconnect(el) {
        unwrapElement(el)?.removeEventListener('scroll', callback);
    }
}
//# sourceMappingURL=onElementScroll.js.map